module.exports = __webpack_public_path__ + "static/media/1_A1_16.19bb63bb.png";